const accountsURL = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_ACCOUNTS}`;
export const Comments = `${accountsURL}/comments`;
export const AUDITS_EVENT = `${accountsURL}/scheduler/events`;
export const UPDATE_SCHEDULER = `${accountsURL}/scheduler/update`;
export const MilestoneDetails = `${accountsURL}/milestonestatus`;
export const OcComments = `${accountsURL}/device-level-updates/comments`;

const DEFAULT_REVEAL_ACCOUNT_LOOKUP_URL = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_ACCOUNTS}/api/v1/getAccountByNumber`;

export const LOOKUP_REVEAL_ACCOUNT_STATUS = process.env.REACT_APP_REVEAL_ACCOUNT_LOOKUP_URL || DEFAULT_REVEAL_ACCOUNT_LOOKUP_URL;
export const ACCOUNT_SUSPEND_ACTION_BASE = `${accountsURL}/account-suspend`;
